import store from '../../../../state';
import { SoundingChart } from '../../../SoundingChart';
import { ForecastWidgetConfig, WidgetRenderContext, WidgetRenderer } from '../types';

export class SoundingWidget implements WidgetRenderer {
  public renderHtml(_widget: ForecastWidgetConfig, _ctx: WidgetRenderContext): string {
    return `
      <div class="metric-card" style="background: rgba(255,255,255,0.03); border: 1px solid var(--border-light); border-radius: 8px; padding: 12px;">
        <div id="poi-sounding-card-container"></div>
      </div>
    `;
  }

  public init(_widget: ForecastWidgetConfig, ctx: WidgetRenderContext): void {
    const container = document.getElementById('poi-sounding-card-container');
    const data = ctx.data;
    if (!container || !data.soundings || data.soundings.length === 0) return;

    const isImperial = store.getState().units === 'imperial';

    if (ctx.soundingChartRef.chart) {
      ctx.soundingChartRef.chart.destroy();
      ctx.soundingChartRef.chart = null;
    }

    ctx.soundingChartRef.chart = new SoundingChart({
      container,
      soundings: data.soundings,
      inversionMetrics: data.inversionMetrics || [],
      poiElevFt: data.poiElev,
      minElevFt: data.minElev,
      maxElevFt: data.maxElev,
      isImperial,
      initialHourIdx: 0
    });
  }
}
